import React from "react";
import { Phone, Mail, Instagram, Linkedin, Twitter, Youtube } from "lucide-react";
import Logo from "./Logo";

const linkGroups = [
  {
    title: "Solutions",
    links: [
      { label: "AI Receptionists", href: "#services" },
      { label: "Automation Systems", href: "#services" },
      { label: "Lead Funnels", href: "#services" },
      { label: "Website Design", href: "#services" },
      { label: "Mobile Apps", href: "#services" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Why Core Scale", href: "#why" },
      { label: "AI System", href: "#ai-system" },
      { label: "Process", href: "#process" },
      { label: "Business Needs", href: "#needs" },
    ],
  },
  {
    title: "Contact",
    links: [
      { label: "214-983-8371", href: "tel:2149838371" },
      { label: "erik@corescaleagency.com", href: "mailto:erik@corescaleagency.com" },
      { label: "corescaleagency.com", href: "#top" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      className="relative border-t border-white/5 bg-[#040404]"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-10 lg:pb-10 pb-32">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Logo size="lg" />
            <p className="mt-5 text-zinc-400 max-w-sm leading-relaxed">
              Core Scale Agency builds modern growth systems for businesses —
              AI agents, automation, premium websites, and custom integrations.
            </p>

            <div className="mt-6 space-y-2">
              <a
                href="tel:2149838371"
                className="flex items-center gap-3 text-zinc-300 hover:text-white transition"
                data-testid="footer-phone-link"
              >
                <Phone className="w-4 h-4 text-[#39FF14]" />
                <span className="font-mono">214-983-8371</span>
              </a>
              <a
                href="mailto:erik@corescaleagency.com"
                className="flex items-center gap-3 text-zinc-300 hover:text-white transition"
                data-testid="footer-email-link"
              >
                <Mail className="w-4 h-4 text-[#39FF14]" />
                erik@corescaleagency.com
              </a>
            </div>

            <div className="mt-7 flex items-center gap-3">
              {[
                { Icon: Instagram, label: "Instagram" },
                { Icon: Linkedin, label: "LinkedIn" },
                { Icon: Twitter, label: "X" },
                { Icon: Youtube, label: "YouTube" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  className="w-9 h-9 rounded-full border border-white/10 bg-white/[0.02] flex items-center justify-center text-zinc-400 hover:text-[#39FF14] hover:border-[#39FF14]/40 transition-all"
                  data-testid={`footer-social-${label.toLowerCase()}`}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {linkGroups.map((g) => (
              <div key={g.title}>
                <div className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500">
                  {g.title}
                </div>
                <ul className="mt-4 space-y-2.5">
                  {g.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        className="text-sm text-zinc-300 hover:text-[#39FF14] transition"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-zinc-500 font-mono">
            © {new Date().getFullYear()} Core Scale Agency · All systems
            engineered for growth.
          </div>
          <div className="text-xs text-zinc-500 flex items-center gap-2 font-mono">
            <span className="live-dot" />
            SYSTEMS OPERATIONAL
          </div>
        </div>
      </div>
    </footer>
  );
}
